const RadioUnchecked = (props: { color: string; hover: boolean; backgroundColor?: string }) => {
    const bg = props.backgroundColor ?? 'white';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24px"
            width="24px"
            viewBox="0 0 24 24"
            fill={props.color}
        >
            {props.hover ? (
                <circle cx="12" cy="12" r="8" stroke={bg} strokeWidth="2" fill={props.color} />
            ) : (
                <circle cx="12" cy="12" r="8" stroke={props.color} strokeWidth="1" fill={bg} />
            )}
        </svg>
    );
};

export default RadioUnchecked;
